<template>
  <el-form class="option-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="oneFlag">
      <template slot="label">数量</template>
      <el-radio-group v-model="control.oneFlag" @change="clearDefaultVal">
        <el-radio :label="true">单选</el-radio>
        <el-radio :label="false">多选</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item prop="countLimit" v-if="!control.oneFlag">
      <template slot="label">可选数量</template>
      <template>
        <div>
          <el-checkbox :value="!_.isEmpty(control.countLimit)" @input="changeCountLimit">
            限定可选数量
          </el-checkbox>
        </div>
        <template v-if="!_.isEmpty(control.countLimit)">
          <el-input-number
            :value="control.countLimit[0] === null ? undefined : control.countLimit[0]"
            @input="$set(control.countLimit, 0, $event)"
            placeholder="最少值"
            :min="0"
            :max="control.countLimit[1] === null ? control.options.length : control.countLimit[1]"
            size="small"
            style="width: 40%"
            type="number"
          ></el-input-number>
          <span>～</span>
          <el-input-number
            :value="control.countLimit[1] === null ? undefined : control.countLimit[1]"
            @input="$set(control.countLimit, 1, $event)"
            placeholder="最多值"
            :min="control.countLimit[0] === null ? 1 : control.countLimit[0]"
            size="small"
            :max="control.options.length"
            style="width: 40%"
            type="number"
          ></el-input-number>
        </template>
      </template>
    </el-form-item>
    <el-form-item prop="options">
      <template slot="label">选项</template>
      <option-setting
        :control="control"
        :sheet-id="sheet.sheetId"
        :app-id="sheet.appId"
        :available-sheets="availableSheets"
        :available-sheet-map="availableSheetMap"
      ></option-setting>
    </el-form-item>
    <el-form-item prop="likeSelect">
      <template slot="label">样式</template>
      <el-radio-group v-model="control.likeSelect" @change="changeStyle">
        <el-radio :label="true">下拉菜单</el-radio>
        <el-radio :label="false">平铺</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item prop="allowAdd">
      <template slot="label">设置</template>
      <div v-if="!Boolean(control.linkage)">
        <el-checkbox
          v-if="control.likeSelect"
          v-model="control.allowAdd"
          label="允许用户新增选项"
        ></el-checkbox>
      </div>
      <div v-if="!control.allowAdd">
        <el-checkbox
          :value="Boolean(control.linkage)"
          label="字段依赖"
          @input="$set(control, 'linkage', $event ? {} : null)"
        ></el-checkbox>
        <el-button
          v-if="Boolean(control.linkage)"
          @click="$refs.optionLinkageDialog.open()"
          type="text"
          style="margin-left: 10px"
        >
          设置
        </el-button>
      </div>
    </el-form-item>
    <el-form-item prop="hint">
      <template slot="label">
        提示
      </template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        标题
      </template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
    <option-linkage-dialog
      ref="optionLinkageDialog"
      :control="control"
      :sheet="sheet"
    ></option-linkage-dialog>
  </el-form>
</template>

<script>
import OptionSetting from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/OptionSetting"
import OptionLinkageDialog from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/OptionLinkageDialog"
export default {
  name: "option-control",
  components: { OptionLinkageDialog, OptionSetting },
  props: {
    control: Object,
    sheet: Object,
    availableSheetMap: Object,
    availableSheets: Array
  },
  data() {
    return {}
  },
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    },
    clearDefaultVal() {
      this.control.defaultVal = []
      if (this.control.oneFlag) {
        this.control.countLimit = []
        this.control._hideAttrs.push("countLimit")
      } else {
        this.control.options.forEach(option => (option.isDefault = ""))
        this.control._hideAttrs = this.control._hideAttrs.filter(attr => attr !== "countLimit")
      }
    },
    changeStyle() {
      if (!this.control.likeSelect) {
        this.control._hideAttrs.push("hint", "allowAdd")
      } else {
        this.control._hideAttrs = this.control._hideAttrs.filter(
          attr => !["hint", "allowAdd"].includes(attr)
        )
      }
    },
    changeCountLimit(selected) {
      this.control.countLimit = selected ? [null, null] : []
    }
  }
}
</script>

<style lang="scss" scoped>
.option-control {
  .option-setting {
    ::v-deep {
      .el-input-group__append {
        .el-radio__label {
          display: none;
        }
      }
    }
  }
}
</style>
